/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { type TextWithIconProps, TextWithIcons } from './TextWithIcons';
import type WireframeBase from '../../wireframes/WireframeBase';
import { DEFAULT_FONT_SIZE } from '../../wireframes/WireframeBase';
import { omit } from 'lodash';
import type WireframeItem from '../../wireframes/WireframeItem';

export interface WireframeInputProps {
  wireframe: WireframeBase;
}

export type InputFieldProps = {
  textKey: string;
  onChange: (value: string) => void;
  item: Partial<WireframeItem>;
  showIcons?: boolean;
} & WireframeInputProps &
  Partial<TextWithIconProps>;

export const InputField: CanvaSXFC<InputFieldProps> = function (props) {
  const {
    textKey,
    item,
    wireframe,
    showIcons = true,
    setRenderedDimensions,
  } = props;
  const { activeKey, fabricObject } = wireframe;
  const { iconLeft, iconRight } = item;
  const textProps = omit(props, 'children');

  return (
    <TextWithIcons
      textEditing={fabricObject.textEditing && activeKey.includes(textKey)}
      size={DEFAULT_FONT_SIZE}
      iconLeft={showIcons ? iconLeft : undefined}
      iconRight={showIcons ? iconRight : undefined}
      {...textProps}
      verticalAlignment='center'
      setRenderedDimensions={setRenderedDimensions}
    >
      {item.value}
    </TextWithIcons>
  );
};
